/**
 * Explore typed search via Mongo `machines` is enabled only when the casino
 * object has insightInstance === 1. Any other value (or none) keeps today's
 * GetSearchData / Search.tsx behavior unchanged.
 */

export const INSIGHT_SEARCH_INSTANCE = 1;

export function isInsightSearchCasino(
  insightInstance: number | null | undefined
): boolean {
  return insightInstance === INSIGHT_SEARCH_INSTANCE;
}
